import * as React from "react";
import { Pie, PieChart } from "recharts";
import SeveritySummary from "../commons/model/treatment/SeveritySummary";
import "./SeverityChart.scss";

interface SeverityChartProps {
  pieSize: number;
  summary: SeveritySummary[];
}

export default function SeverityChart({ pieSize, summary }: SeverityChartProps) {
  return (
    <PieChart width={pieSize} height={pieSize} className="severity-chart">
      <Pie
        data={summary}
        dataKey="total"
        animationDuration={500}
        startAngle={90}
        endAngle={-270}
        outerRadius="100%"
      />
    </PieChart>
  );
}
